// 默认筛选条件
export const defaultDataSource = JSON.stringify({ query: { bool: { must: [], must_not: [] } } });

// 去除前缀 #段落名#
export const paragraphRegexp = /^#.*?#/;

// 去除字符串内所有 #段落名#
export const paragraphRegexpAll = /#.*?#/g;

// 去除字符串前后符号
export const delEmptyRegexp = /^[+|&]+|[-+|&]+$/g;

export const selectStatistics = [
  { title: '案件数', value: 'row_count' },
  { title: '平均值', value: 'avg' },
  { title: '最大值', value: 'max' },
  { title: '最小值', value: 'min' },
  { title: '总和', value: 'sum' }
];

export const dayUnixValue = 86400000;

// 下载的静态文件域名
export const staticOrigin = window.location.origin;

// 废弃
// export const defaultStatistic = {
//   ...selectStatistics[0],
//   isStatistic: true,
//   fieldDetail: {
//     columnKey: 'caseId',
//     field_name: 'caseId',
//     title: '案件数',
//     type: 'num',
//     isDefaultStatistic: true,
//     caseTotal: true
//   }
// };

// 废弃
// export const tagStatistic = {
//   ...selectStatistics[1],
//   isStatistic: true,
//   fieldDetail: {
//     columnKey: 'caseId',
//     field_name: 'caseId',
//     title: '标签数',
//     type: 'num',
//     isDefaultStatistic: true,
//     tagTotal: true
//   }
// };

export const emptyColumnText = '其他';

export const numEnum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];

export const caseTypeList = ['刑事', '民事', '行政', '国家赔偿', '其他'];

export const defendantNames = {
  title: '被告主体',
  columnKey: 'defendantNames',
  field_name: 'defendantNames',
  type: 'text',
  deputy_type: ''
};

export const fullCrimeReason = {
  title: '案由',
  columnKey: 'full_crime_reason',
  field_name: 'full_crime_reason',
  type: 'text',
  deputy_type: 'dict'
};

export const caseBaseTitle = {
  title: '标题',
  columnKey: 'base_title',
  field_name: 'base_title',
  type: 'text',
  deputy_type: ''
};

export const caseNumber = {
  title: '案号',
  columnKey: 'base_caseNumber',
  field_name: 'base_caseNumber',
  type: 'text',
  deputy_type: ''
};

export const judgementDate = {
  title: '裁判日期',
  columnKey: 'judgementDate',
  field_name: 'judgementDate',
  type: 'date'
};

// 废弃，修改为自定义分组
// export const unitArr = [
//   { value: 'case', statisticFieldId: 'caseId', label: '以案件为单位', statisticName: '案件数' },
//   { value: 'defendantNames', statisticFieldId: 'defendantNames', label: '以被告人为单位', statisticName: '被告人数' }
//   // { value: 'full_crime_reason', statisticFieldId: 'full_crime_reason', label: '以案由为单位', statisticName: '案由数' }
// ];

// 检察文书
export const procuratorateNature = [
  '起诉书',
  '不起诉决定书',
  '抗诉书',
  '刑事申诉复查决定书',
  '刑事赔偿决定书',
  '其他法律文书'
];

// 裁判文书
export const baseNature = ['判决书', '裁定书', '调解书', '决定书', '通知书', '令', '其他'];

export const chartThemeColors = [
  ['#0b8dff', '#03dbcd', '#ffd600', '#ff8a00', '#fc752d', '#7f49ff', '#6547ff', '#81e600', '#10cc63'],
  ['#1991FB', '#04C8BB', '#FFC400', '#FFA938', '#F16718', '#684AFD', '#2B4DFA', '#DF20F8', '#F12A69'],
  ['#13E17D', '#0FCE4B', '#00B0FF', '#2979FF', '#651FFF', '#FFC400', '#FF9100', '#505D6F', '#37474F'],
  ['#FFC400', '#FFA938', '#0FCE4B', '#5ED512', '#4CAF50', '#00967C', '#651FFF', '#2E7AFA', '#00B0FF'],
  ['#F12A69', '#2E7AFA', '#3DDEE0', '#843CF7', '#381CE2', '#E33867', '#F7A42C', '#004B91', '#3556F6'],
  ['#FCED66', '#FEE829', '#FEE100', '#FED800', '#FEC600', '#FBAF2D', '#FBA720', '#F89426', '#F98620'],
  ['#80CBC4', '#4DB6AC', '#26A69A', '#15988C', '#01877B', '#027E70', '#007063', '#005E52', '#015648'],
  ['#80DEEA', '#4DD0E1', '#26C6DA', '#00BCD4', '#00ACC1', '#0097A7', '#00838F', '#005C60', '#014E51'],
  ['#90CAF9', '#64B5F6', '#42A5F5', '#2196F3', '#1E88E5', '#1976D2', '#1565C0', '#1654B3', '#0D47A1'],
  ['#9DDBFF', '#8DCDFF', '#72BFFA', '#52BDFF', '#1EA3FF', '#0C93F2', '#2490F4', '#2483F4', '#0975EE'],
  ['#E6EAEE', '#D4DBE3', '#B4BECA', '#9CA6B5', '#727D8D', '#616C7C', '#515B6E', '#454F63', '#2C3443'],
  ['#1991fb', '#1991fb', '#1991fb', '#1991fb', '#1991fb', '#1991fb', '#1991fb', '#1991fb', '#1991fb']
];

export const metadataTypes = [
  // { value: 1, label: '仅下载原句标注' },
  { value: 2, label: '仅下载标签标注', subLabel: '导出元数据' },
  { value: 3, label: '下载原句及标签标注', subLabel: '导出元数据（含原句）' }
];

export const specialSymbolEnum = {
  '&quot;': '"',
  '&times;': '×',
  '&larr;': '←',
  '&amp;': '&',
  '&divide;': '÷',
  '&uarr;': '↑',
  '&lt;': '<',
  '&plusmn;': '±',
  '&rarr;': '→',
  '&gt;': '>',
  '&darr;': '↓',
  '&nbsp;': '',
  '&radic;': '√',
  '&infin;': '∞',
  '&ang;': '∠',
  '&int;': '∫',
  '&lsquo;': '‘',
  '&deg;': '°',
  '&rsquo;': '’',
  '&ne;': '≠',
  '&ldquo;': '“',
  '&equiv;': '≡',
  '&rdquo;': '”',
  '&le;': '≤',
  '&ge;': '≥',
  '&sect;': '§',
  '&perp;': '⊥',
  '&alpha;': 'α',
  '&beta;': 'β',
  '&gamma;': 'γ',
  '&permil;': '‰',
  '&Delta;': 'Δ',
  '&cent;': '￠',
  '&there4;': '∴',
  '&theta;': 'θ',
  '&pound;': '￡',
  '&pi;': 'π',
  '&lambda;': 'λ',
  '&yen;': '￥',
  '&sup1;': '1',
  '&Sigma;': 'Σ',
  '&hellip;': '…',
  '&sup2;': '2',
  '&tau;': 'τ',
  '&mdash;': '—'
};

export const sysCaseWays = ['裁判文书', '检察文书'];
export const sysDataWays = [...sysCaseWays, '行政处罚文书'];
export const sysExtractWays = [...sysCaseWays, '起诉意见书'];
